import styled from "styled-components";
import { Button } from "../../AppStyle";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 40px;

  .text-wrapper {
    display: flex;
    flex-direction: column;
    padding: 60px 40px;
    max-width: 700px;
    align-items: flex-start;
  }
  .Title {
    font-size: 35px;
    line-height: 1.2;
    color: ${({ theme }) => theme.text};
    padding-bottom: 20px;
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
    font-weight: 700;
    word-spacing: 5px;
    text-align: start;
  }
  .DescriptionSubtext {
    font-size: 18px;
    color: ${({ theme }) => theme.text};
    padding-bottom: 20px;
    word-spacing: 5px;
  }
  .Subtitle {
    color: ${({ theme }) => theme.text};
    font-weight: bold;
    word-spacing: 5px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 20px;

    img {
      display: block;
      width: 80%;
      max-width: 300px;
      margin: 0 auto 20px;
    }

    .text-wrapper {
      padding: 20px 0px;
      align-items: center;
      text-align: flex-start;
    }

    .Title {
      font-size: 32px;
      line-height: 1.3;
    }
  }
`;

export const HeroButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 35px;
  color: black;
  border-radius: 15px;
  border: none;
  background: #dddf21;
  font-size: 15px;
  margin: 20px 0;
  font-weight: 500;

  &:before {
    height: 500%;
  }

  &:hover:before {
    height: 0%;
  }

  &:hover {
    color: black;
    background-color: rgba(164, 166, 38, 0.85);
    transition-duration: 0.1s;
  }

  &:active {
    background-color: rgba(159, 159, 25, 0.83);
    color: black;
    transition-duration: 0.1s;
  }

  @media screen and (max-width: 1200px) {
    font-size: 17px;
    width: 100%;
    max-width: 400px;
    height: 3rem;
    margin: 20px auto 30px;
    border-radius: 30px;
  }
`;

export const CheckList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const CheckItem = styled.li`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text};
  font-size: 16px;
  margin-bottom: 18px;
`;

export const CheckIcon = styled.span`
  color: #dddf22;
  margin-right: 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
`;
